// Split auth shell: left navy panel with real photo + wordmark, right white form.
import { Link } from "react-router-dom";
import { PHOTOS } from "../lib/photos";
import { Wordmark as BrandWordmark } from "./Brand";

function Wordmark() {
  return <BrandWordmark tone="dark" size="lg" />;
}

export default function AuthShell({ title, subtitle, children, dataTestId }) {
  return (
    <div className="min-h-screen bg-[#F4F5EF] grid lg:grid-cols-[1.1fr_1fr]" data-testid={dataTestId}>
      {/* Left decorative panel with real bistro photo */}
      <aside className="relative hidden lg:block overflow-hidden">
        <img src={PHOTOS.bistroWarm} alt="Ambiance restaurant" className="absolute inset-0 w-full h-full object-cover" />
        <div aria-hidden className="absolute inset-0 bg-gradient-to-b from-[#0B1F33]/85 via-[#0B1F33]/70 to-[#0B1F33]/90" />
        <div className="relative h-full p-10 xl:p-14 flex flex-col text-white">
          <Link to="/"><Wordmark /></Link>
          <div className="mt-16 max-w-md">
            <div className="text-[11.5px] font-bold uppercase tracking-[0.16em] text-[#FFD166]">Marges · Restauration · Bars</div>
            <h2 className="mt-4 display-3 text-white">Vérifions votre marge ensemble.</h2>
            <p className="mt-4 text-[15px] text-white/80 leading-relaxed">RentaScan sera votre meilleur allié contre la hausse des prix.</p>
          </div>

          <div className="mt-auto pt-10 grid grid-cols-3 gap-6">
            <div><div className="text-[22px] font-extrabold tabular-nums text-[#FFD166]">Moins d'1 min</div><div className="text-[11px] text-white/60 mt-0.5">par facture</div></div>
            <div><div className="text-[22px] font-extrabold tabular-nums text-[#FFD166]">100 %</div><div className="text-[11px] text-white/60 mt-0.5">hausses détectées</div></div>
            <div><div className="text-[22px] font-extrabold tabular-nums text-[#FFD166]">7 langues</div><div className="text-[11px] text-white/60 mt-0.5">au menu QR</div></div>
          </div>
        </div>
      </aside>

      {/* Right — form */}
      <main className="relative flex flex-col">
        <div className="lg:hidden px-5 py-5 border-b border-[#CDD7E3] bg-[#0B1F33]">
          <Link to="/"><Wordmark /></Link>
        </div>
        <div className="flex-1 flex items-center justify-center px-5 sm:px-10 py-12">
          <div className="w-full max-w-md">
            <h1 className="page-title">{title}</h1>
            {subtitle && <p className="page-subtitle">{subtitle}</p>}
            <div className="mt-8">{children}</div>
          </div>
        </div>
      </main>
    </div>
  );
}
